// extracted by mini-css-extract-plugin
export default {"noMobilePressEffects":"ThemeProvider_noMobilePressEffects__RhBB6"};